import { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router';

import SkipLink from './components/SkipLink';
import Home from './pages/Home';
import NotFound from './pages/NotFound';

// Split the listing detail route into its own chunk — it pulls in leaflet,
// which the landing page never needs.
const ListingDetail = lazy(() => import('./pages/ListingDetail'));

function RouteFallback() {
  return <div className="min-h-screen bg-bg" aria-hidden />;
}

export default function App() {
  return (
    <>
      <SkipLink />
      <Suspense fallback={<RouteFallback />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/stays/:id" element={<ListingDetail />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </>
  );
}
